module.exports = __webpack_public_path__ + "img/salon-kids-friendly.52993f2a.svg";